module.exports = __webpack_public_path__ + "media/svg/hu-e6a8aa4d.svg";